import React, { useState } from 'react';
import { Copy, CheckCircle2 } from 'lucide-react';

function truncate(value, head = 25, tail = 8) {
  if (!value) return 'N/A';
  if (value.length <= head + tail + 3) return value;
  return `${value.slice(0, head)}...${value.slice(-tail)}`;
}

/**
 * variant="box"    -> label on its own line, full value in a bordered row (deposit address, memo)
 * variant="inline" -> label left, truncated value + icon right (recipient, refund, tx hash)
 */
const CopyRow = ({ label, value, variant = 'box' }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard access denied — nothing we can do beyond leaving the value visible to select manually
    }
  };

  const icon = copied ? <CheckCircle2 size={16} color="var(--mint-500)" /> : <Copy size={16} />;

  if (variant === 'inline') {
    return (
      <div className="detail-row" onClick={copy}>
        <span className="detail-label">{label}</span>
        <span className="detail-value-with-icon">
          {truncate(value)}
          <span className="copy-icon-inline">{icon}</span>
        </span>
      </div>
    );
  }

  return (
    <div className="copy-field">
      <label>{label}</label>
      <div className="copy-row" onClick={copy}>
        <span className="copy-text">{value || 'N/A'}</span>
        <span className="copy-icon-inline">{icon}</span>
      </div>
    </div>
  );
};

export default CopyRow;
